import { Type } from "@angular/core";
import { EndpointComponent } from "./endpoint.component";

export const ENDPOINT_DIRECTIVES: Type<any>[] = [EndpointComponent];
